// Module
var code = "<a href=\"javascript:;\" class=\"btn blue-sharp subFormControl\"> <i class=\"icon-pointer\"></i> Google Maps </a>";
// Exports
export default code;